const fontFaces = `
	@font-face {
	    font-family: 'DINPro';
	    font-weight: normal;
	    src: url('/fonts/DinPro/DIN_Pro.otf') format('opentype'),
	    url('/fonts/DinPro/DIN_Pro.ttf') format('truetype'),
	    url('/fonts/DinPro/DIN_Pro.eot') format('embedded-opentype');
	}

	@font-face {
	    font-family: 'DINPro';
	    font-weight: 500;
	    src: url('/fonts/DinPro/DIN_Pro_Medium.otf') format('opentype'),
	    url('/fonts/DinPro/DIN_Pro_Medium.ttf') format('truetype'),
	    url('/fonts/DinPro/DIN_Pro_Medium.eot') format('embedded-opentype');
	}

	@font-face {
	    font-family: 'DINPro';
	    font-weight: bold;
	    src: url('/fonts/DinPro/DIN_Pro_Bold.otf') format('opentype'),
	    url('/fonts/DinPro/DIN_Pro_Bold.ttf') format('truetype'),
	    url('/fonts/DinPro/DIN_Pro_Bold.eot') format('embedded-opentype');
	}

	@font-face {
	    font-family: 'DINPro';
	    font-weight: normal;
	    font-style: italic;
	    src: url('/fonts/DinPro/DIN_Pro_Italic.otf') format('opentype'),
	    url('/fonts/DinPro/DIN_Pro_Italic.ttf') format('truetype'),
	    url('/fonts/DinPro/DIN_Pro_Italic.eot') format('embedded-opentype');
	}

	@font-face {
	    font-family: 'DINPro';
	    font-weight: 500;
	    font-style: italic;
	    src: url('/fonts/DinPro/DIN_Pro_Medium_Italic.otf') format('opentype'),
	    url('/fonts/DinPro/DIN_Pro_Medium_Italic.ttf') format('truetype'),
	    url('/fonts/DinPro/DIN_Pro_Medium_Italic.eot') format('embedded-opentype');
	}
`;

export default fontFaces;
